import { useQuery } from '@tanstack/react-query';
import { brandingService } from '../services/branding.service';

export const brandingKeys = {
  all: ['branding'] as const,
  logos: () => [...brandingKeys.all, 'logos'] as const,
};

/**
 * Hook to fetch branding logo URLs (light/dark variants).
 * Must be used inside AuthProvider context so requests include the auth token.
 */
export const useBrandingLogos = (enabled = true) => {
  return useQuery({
    queryKey: brandingKeys.logos(),
    queryFn: () => brandingService.getLogoUrls(),
    enabled,
    staleTime: 15 * 60 * 1000, // 15 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
    retry: false,
  });
};
